import { Component, OnInit } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { RefreshauthService } from './service/refreshauth.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-refreshauth',
  templateUrl: './refreshauth.component.html',
  styleUrls: ['./refreshauth.component.css']
})
export class RefreshauthComponent implements OnInit {
  constructor(private rasrv:RefreshauthService) { }

  showspinner:boolean = false;
  updated:boolean = false;

  ngOnInit(): void {
  }
  refresh(){
    this.showspinner = true;
    if(SessionHelper.getCustomer()){
      this.rasrv.refreshCustomerAuth(SessionHelper.getChoosenOrg(),SessionHelper.getUserSub()).pipe(untilDestroyed(this)).subscribe(x => {
        //console.log(x);
        this.showspinner = false;
        this.updated = true;
      });
    }else{
      this.rasrv.refreshPersonAuth(SessionHelper.getChoosenOrg(),SessionHelper.getUserSub()).pipe(untilDestroyed(this)).subscribe(x => {
        //console.log(x);
        this.showspinner = false;
        this.updated = true;
      });
    }
    
  }
}
